module.exports = __webpack_public_path__ + "static/img/0544_5.7de76d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0544_5.jpg
// module id = OaLJ
// module chunks = 1